import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ApiPromotionMissionEvent } from 'api/Promotion';
import { convertStyle } from 'utils/Style';

import Header from 'component/common/header/Header';
import MobileNav from 'component/common/nav/MobileNav';

import Footer from 'component/common/footer/Footer';
import TopBtn from 'component/common/button/top/TopBtn';

import SubNav from 'component/common/nav/SubNav';

import Profile from './mission_event_tmpl/Profile';
import Mission from './mission_event_tmpl/Mission';
import DpList from './mission_event_tmpl/DpList';
import Notice from './mission_event_tmpl/Notice';

import promotionStyle from './style/Promotion.module.scss';
import missionStyle from './style/MissionEvent.module.scss';

import img_mission_1 from 'assets/images/promotion/misson_1.png';
import img_mission_2 from 'assets/images/promotion/misson_2.png';
import useAlertModal from 'component/common/modal/useAlertModal';
import { useBookpalNavigate } from 'component/common/custom/BookpalLink';


const style = { ...promotionStyle, ...missionStyle };

function MissionEvent(){
    const location = useLocation();
    const navigate = useBookpalNavigate();
    const queryParams = new URLSearchParams(location.search);

    // const eventId = queryParams.get("event_id");

    const {event_id} = useParams();
    const eventId = event_id;

    const [data, setData] = useState(null);
    const [missionData, setMissionData] = useState(null);
    const [dpData, setDpData] = useState(null);

    const [AlertModal, alert] = useAlertModal();

    const missionEventSubmit = ApiPromotionMissionEvent({
        onSuccess:(_data)=>{
            console.log(_data);
            if(_data?.status === true){
                const result = _data?.result;
                setData(result?.data);
                setMissionData(result?.mission_data);
                setDpData(result?.dp_data);
                return;
            }

            alert("잘못된 접근 입니다.",null,()=>{
                // missionEventSubmit({
                //     event_id:eventId,
                // })
                navigate(-1);
            },true);
        },
        onError:(e)=>{
            alert("통신에 실패하였습니다.",null,()=>{
                navigate(-1);
            },true);
        }
    });

    useEffect(()=>{
        missionEventSubmit({
            event_id:eventId,
        })
    },[])

    if(data === null){
        return (
            <>
                <Header useMobile={false} />
                {/* <MobileNav /> */}
                {/* <!-- 서브메뉴 --> */}
                <SubNav name="이벤트" 
                    useHome={true} 
                    usePc={true} 
                    useMobile={true}
                    useBtnHome={true}
    
                    useBtnPrev={true}
                    setTop={"0px"}
                />
                <AlertModal />
            </>
        );
    }


    return (
        <>
            <Header useMobile={false} />
            {/* <MobileNav /> */}
            {/* <!-- 서브메뉴 --> */}
            <SubNav name={data?.title} 
                useHome={true} 
                usePc={true} 
                useMobile={true}
                useBtnHome={true}

                useBtnPrev={true}
                setTop={"0px"}
            />

            <div id="container" >
                {/* <!-- 섹션 --> */}
                <section className={convertStyle(style, "section wrapper")}>
                    {/* <!-- 이미지 --> */}
                    <p className={convertStyle(style, "images")}>
                        <img src={data?.img_event} />
                        <img src={data?.img_info} />
                    </p>
                    <div className={convertStyle(style, "missonBox typeList")}>
                        {/* <!-- 프로모션 --> */}
                        <div className={convertStyle(style, "missonContent")} style={{backgroundColor: data?.bg_color}}>
                            {/* <!-- 프로필 --> */}
                            <Profile 
                                data={data}
                                />
                            {/* <!-- 미션 --> */}
                            <div className={convertStyle(style, "misson_List")}>
                                {Array.isArray(missionData) && missionData?.length > 0 ?
                                    missionData.map((item,index)=>{
                                        return (
                                            <Mission key={index} index={index} data={item}/>
                                        );
                                    })
                                    
                                :null}
                            </div>
                        </div>

                        {/* <!-- 미션 대상 작품 --> */}
                        <DpList 
                            random={data?.dp_random_yn === "Y"}
                            data={dpData}
                            alert={alert}
                        />
                    
                        {/* <!-- 공지사항 --> */}
                        <Notice 
                            txt={data?.txt_info}
                        />

                    </div>
                </section>
            </div>

            <Footer />
            <TopBtn />
            <AlertModal />
        </>
    )
}



export default MissionEvent;